import React, {
  useLayoutEffect,
  useRef,
} from 'react';

import {
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import GuestRoute
  from './GuestRoute';

import ProtectedRoute
  from './ProtectedRoute';

import ResourceAccessRoute
  from './ResourceAccessRoute';

import UpdateNoticeRoute
  from './UpdateNoticeRoute';

import ContactAccessRoute
  from './ContactAccessRoute';

import SignUpPage
  from '../features/auth/sign-up/SignUpPage';

import MainLayout
  from '../shared/layouts/MainLayout/MainLayout';

import HomePage
  from '../features/home/HomePage';

import LoginPage
  from '../features/auth/login/LoginPage';

import FindAccountPage
  from '../features/auth/find-account/FindAccountPage';

import MemberInfoPage
  from '../features/account/member-info/MemberInfoPage';

import LicenseInfoPage
  from '../features/account/license-info/LicenseInfoPage';

import StatePage
  from '../features/system/state/StatePage';

import ProductIntroPage
  from '../features/portal-content/products/ProductIntroPage';

import { productPages } from '../features/portal-content/products/registry';
import EquipmentIntroPage from '../features/equipment/EquipmentIntroPage';
import EquipmentDetailPage from '../features/equipment/EquipmentDetailPage';
import { equipmentRegistry } from '../features/equipment/registry';

import StartNowPage
  from '../features/portal-content/start-now/StartNowPage';

import SuccessStoriesPage
  from '../features/portal-content/success-stories/SuccessStoriesPage';

import ELearningPage
  from '../features/portal-content/e-learning/ELearningPage';

import {
  ROUTES,
} from '../config/routes';


export default function AppRoutes() {
  const location =
    useLocation();

  const previousPathRef =
    useRef(
      location.pathname,
    );

  useLayoutEffect(() => {
    const previousRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => {
      window.history.scrollRestoration = previousRestoration;
    };
  }, []);

  useLayoutEffect(
    () => {
      const previousPath =
        previousPathRef.current;

      const currentPath =
        location.pathname;

      const isPreviousUpdateNotice =
        previousPath.startsWith(
          '/updatenotices',
        );

      const isCurrentUpdateNotice =
        currentPath.startsWith(
          '/updatenotices',
        );

      previousPathRef.current =
        currentPath;

      if (
        currentPath === ROUTES.root ||
        location.hash
      ) {
        return;
      }

      if (
        isPreviousUpdateNotice &&
        isCurrentUpdateNotice
      ) {
        return;
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      });
    },
    [
      location.pathname,
      location.hash,
    ],
  );

  return (
    <Routes>
      <Route
        element={
          <GuestRoute />
        }
      >
        <Route
          path={
            ROUTES.login
          }
          element={
            <LoginPage />
          }
        />

        <Route
          path={
            ROUTES.findAccount
          }
          element={
            <FindAccountPage />
          }
        />

      </Route>

      <Route
        path={
          ROUTES.signup
        }
        element={
          <SignUpPage />
        }
      />

      <Route
        path={
          ROUTES.root
        }
        element={
          <MainLayout />
        }
      >

        <Route
          index
          element={
            <HomePage />
          }
        />

        <Route
          path={
            ROUTES.products
          }
          element={
            <ProductIntroPage />
          }
        />

        <Route
          path={
            ROUTES.equipmentIntro
          }
          element={
            <EquipmentIntroPage />
          }
        />

        {equipmentRegistry.map(equipment => (
          <Route key={equipment.id} path={equipment.path} element={<EquipmentDetailPage equipment={equipment} />} />
        ))}

        {productPages.map(({ product, Component }) => (
          <Route key={product.id} path={product.path} element={<Component />} />
        ))}

        <Route
          path={
            ROUTES.successStories
          }
          element={
            <SuccessStoriesPage />
          }
        />

        <Route
          path={
            ROUTES.resources
          }
          element={
            <ResourceAccessRoute />
          }
        />

        <Route
          path={
            `${ROUTES.updatenotices}/*`
          }
          element={
            <UpdateNoticeRoute />
          }
        />

        <Route
          path={
            ROUTES.elearning
          }
          element={
            <ELearningPage />
          }
        />

        <Route
          path={
            ROUTES.startNow
          }
          element={
            <StartNowPage />
          }
        />

        <Route
          path={
            ROUTES.contact
          }
          element={
            <ContactAccessRoute />
          }
        />

        <Route
          element={
            <ProtectedRoute />
          }
        >
          <Route
            path={
              ROUTES.memberInfo
            }
            element={
              <MemberInfoPage />
            }
          />

          <Route
            path={
              ROUTES.licenseInfo
            }
            element={
              <LicenseInfoPage />
            }
          />


        </Route>

        <Route
          path="*"
          element={
            <StatePage
              icon="warning"
              titleKey="state.notFound.title"
              descriptionKey="state.notFound.description"
              actionKey="state.notFound.gomemberInfo"
              actionPath={
                ROUTES.root
              }
            />
          }
        />
      </Route>
    </Routes>
  );
}
